<div class="landing-container">
    <div id="header" class="section p-d-flex p-flex-column">
        <table>
            <tr>
                <td style="text-align: center; width: 25%;">
                    <div class="header-menu-container p-shadow-5 p-d-flex p-ai-center p-jc-between">
                        <a class="layout-topbar-logo" routerLink="#">
                            <img src="assets/layout/images/logo2x___.png" alt="ultima-layout" style="height: 70px">
                        </a>
                    </div>
                </td>
                <td style="text-align: center; width: 75%;">
                    <div class="header-text p-d-flex p-flex-column p-ai-center p-jc-left">
                        <h3 class="p-mb-0 white-color">TOV INTERNACIONAL</h3>
                        <h4 class="p-mb-1 white-color">{{event_group_name_}}</h4>

                    </div>
                </td>
            </tr>
        </table>
    </div>

    <div class="section p-d-flex p-flex-column p-ai-center">
        <p-toast></p-toast>
        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left">
                <button pButton type="button" label=" {{back_}}" *ngIf="!this.hiddenFields" class="p-button-danger"
                    icon="pi pi-chevron-left" (click)="goBack()"></button>
                <button pButton type="button" label=" {{accept_}}" *ngIf="!this.hiddenFields" class="p-button-success"
                    icon="pi pi pi-plus" (click)="goAccept()"></button>
            </ng-template>
        </p-toolbar>

        <p-table #dt [value]="listOptionEvent"
            [globalFilterFields]="['optName','countryName','nationality','shrZoneName','shrNatioName','shrLocalName']"
            [(selection)]="selectedOptions" [rowHover]="true" dataKey="id" styleClass="p-datatable-responsive-demo"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [showCurrentPageReport]="true">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">{{evt?.eventName}}</h5>
                    
                    <span class="p-input-icon-left"  >
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="{{search_}}..." style="width: 140px;"/>
                    </span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between">
                        <h7 class="p-m-0">{{total_guides_to_choose_}}: {{evt?.selecNum}}</h7>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <h7 class="p-m-0">{{choosen_}} {{selectedOptions?.length}} / {{evt?.selecNum}}</h7>
                    </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="select" [hidden]="!checDisaled()">{{select_}}<p-sortIcon field="select">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="selectH" [hidden]="checDisaled()"></th>
                    <th pSortableColumn="optName">{{eligible_guide_}}<p-sortIcon field="optName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="shrZoneName">{{zonal_coordination_}} <p-sortIcon field="shrZoneName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="shrNatioName">{{national_coordination_}} <p-sortIcon field="shrNatioName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="shrLocalName">{{local_coordination_}}<p-sortIcon field="shrLocalName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="nationality">{{nationality_}} <p-sortIcon field="nationality"></p-sortIcon>
                    </th>
                    <th pSortableColumn="countryName">{{country_of_residence}}<p-sortIcon field="countryName">
                        </p-sortIcon>
                    </th>
                    <th pSortableColumn="shortDesc">{{any_zone_team_experience_}} <p-sortIcon field="shortDesc">
                        </p-sortIcon>
                    </th>
                    <th>{{role_}}</th>

                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-opt>
                <tr>
                    <td>
                        <p-checkbox name="group1" value="{{opt.id.sequen}}" [(ngModel)]="selectedOptions"
                            inputId="{{opt.id.sequen}}" (onChange)="checkValue('reviewed',selectedOptions)"
                            [hidden]="!checDisaled()"></p-checkbox>
                    </td>
                    <td>{{opt.optName}}</td>
                    <td>{{opt.shrZoneName}}</td>
                    <td>{{opt.shrNatioName}}</td>
                    <td>{{opt.shrLocalName}}</td>
                    <td>{{opt.nationality}}</td>
                    <td>{{opt.countryName}}</td>
                    <td>{{opt.shortDesc}}</td>
                    <td>{{opt.functionId}}-{{opt.funcLevel}}</td>

                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="p-d-flex p-ai-center p-jc-between">
                    Total {{listOptionEvent ? listOptionEvent.length : 0 }} Options.
                </div>
            </ng-template>
        </p-table>


    </div>

</div>